<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <div class="hxl_title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Home' }">{{
            regulations.law
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="announcement" style="text-align: center">
        <img class="img" :src="productionBaseUrl + imgurl" alt="" />
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="infoTitle"
              label="标题"
              min-width="730px"
            >
              <template slot-scope="scope">
                               
                <span
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  @click="TZ(scope.row)"
                  type="text"
                  >{{ scope.row.articleTitle }}</span
                >
                             
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="displayDate"
              label="发布时间"
              min-width="250px"
            >
              <template slot-scope="scope">{{
                scope.row.publishTime
              }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { URL_CHANNEL_LIST_BYIDS } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
import { productionBaseUrl } from "../../utils/axiosUrl";

export default {
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        law: "首页",
        laws: this.$route.query.channelName,
      },
      legalForms: [],

      productionBaseUrl: productionBaseUrl + ":9002",
      imgurl: this.$route.query.imgurl,
      query: {
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  computed: {},
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    // 解决换页后index从1开始
    count(index) {
      return (this.query.currentPage - 1) * this.query.pagesize + index + 1;
    },
    getList() {
      // let result = frontHeater(["classId"], ["03"]);
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        ...this.query,
        t: {
          channels: [this.$route.query.channelId],
          publishSign: "2",
        },
      };
      // this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      // this.$http.post(Url + URL_PORTAL_FIND, params).then((res) => {
      this.$http.post(Url + URL_CHANNEL_LIST_BYIDS, params).then((res) => {
        if (res.status == 200) {
          this.legalForms = res.data.data.data;
        }
      });
    },
    TZ(val) {
      let routerJump = this.$router.resolve({
        path: "/home/gov-info-disclo",
        query: { id: val.articleId },
      });
      window.open(routerJump.href, "_blank");
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/theme";
@import "../../styles/comSty";

.hxl_title {
  vertical-align: top;
  color: black;
  border-bottom: 1px solid black;
}
.img {
  // width: 100%;
  height: 100px;
  padding: 0 20px;
  margin: 20px 0;
}
/deep/ .el-table .cell span {
  font-size: 16px !important;
}
</style>